module.exports = __webpack_public_path__ + "static/media/bookmark-svgrepo-com (5).cda31536.svg";